import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import IndustriesPage from '@/pages/IndustriesPage';
import Insights from '@/pages/Insights';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';

import CashOnCashYieldTrap from '@/pages/insights/CashOnCashYieldTrap';
import StabilizedYieldPower from '@/pages/insights/StabilizedYieldPower';
import Exchange1031Blueprint from './pages/insights/Exchange1031Blueprint';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Core Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Insights */}
          <Route path="/insights" element={<Insights />} />
          <Route
            path="/insights/cash-on-cash-yield-trap"
            element={<CashOnCashYieldTrap />}
          />
          <Route
  path="/insights/1031-exchange-blueprint"
  element={<Exchange1031Blueprint />}
/>
          <Route
            path="/insights/stabilized-yield-power"
            element={<StabilizedYieldPower />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
